import { Navigate, Link } from 'react-router-dom';
import FullPageError from './FullPageError';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

const PageNotFound = () => {
  const isAuthenticated = useSelector(({ user }) => !!user?.isAuthenticated);
  const location = useLocation();

  // If this user isn't logged in then redirect them to login (and save where they came from).
  // This is to avoid 404 page for role specific routes.
  if (!isAuthenticated) {
    localStorage.setItem('from', location.pathname);
    return <Navigate to="/login" />;
  }

  return (
    <FullPageError
      title="404: Page Not Found"
      description={
        <>
          <p>The page you're looking for doesn't exist</p>
          <Link to="/">Go home</Link>
        </>
      }
    />
  );
};

export default PageNotFound;
